export const validateAgreement = (value: boolean) =>
    value ? undefined : 'Чтобы продолжить, необходимо ваше согласие';
